import React from 'react';
import styled from 'styled-components';
import { IconButton } from './iconButton';
import { Close } from '../icons/actions';

const Button = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: ${({ theme }) => theme.zIndex.closeButton};
`;

export const CloseButton = (props) => (
  <Button {...props} icon={Close} size="28px" />
);
